/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestDefaultOsSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_DEFAULT_OS')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ parsers.exactly('Ubuntu 20.04', 'Ubuntu 24.04')),
    ],
]);
export class NewAutoTestDefaultOsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestDefaultOsSettingParser.decode(input).map(res => new NewAutoTestDefaultOsSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestDefaultOsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestDefaultOsSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestDefaultOsSettingParser.schema();
    }
}
